import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import SimpleCard from '../../components/SimpleCard';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import '../../HelpCenter.css';

/**
 * Getting Started Category Page
 */
const GettingStarted = () => {
  const cards = [
    {
      title: 'Creating an Account',
      description: 'Start managing your expenses in seconds using your phone, email, or Phantom wallet.',
      route: getHelpRoute(getHelpArticleRoute('getting-started', 'welcome'))
    },
    {
      title: 'Secure your Account',
      description: 'Protect your funds and ensure only you have access to your wallet.',
      route: getHelpRoute(getHelpArticleRoute('getting-started', 'first-split'))
    },
    {
      title: 'Top up your account',
      description: 'Add funds to your account to start making payments.',
      route: getHelpRoute(getHelpArticleRoute('getting-started', 'top-up-account'))
    },
    {
      title: 'Create your first group',
      description: 'Create a group to start splitting expenses with friends.',
      route: getHelpRoute(getHelpArticleRoute('getting-started', 'create-group'))
    },
    {
      title: 'Manage your group',
      description: 'Learn how to manage group settings and members.',
      route: getHelpRoute(getHelpArticleRoute('getting-started', 'manage-group'))
    },
    {
      title: 'Top up your group',
      description: 'Add funds to a shared group wallet.',
      route: getHelpRoute(getHelpArticleRoute('getting-started', 'top-up-group'))
    },
    {
      title: 'Withdraw from a group',
      description: 'Withdraw funds from a group wallet to your account.',
      route: getHelpRoute(getHelpArticleRoute('getting-started', 'withdraw-group'))
    }
  ];

  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-center">
        <div className="help-center-container">
          <header className="lp-section-header">
            <h1 className="lp-section-title">Get started</h1>
            <p className="lp-section-subtitle">
              Set up your account and create your first group in minutes.
                </p>
          </header>

          <section className="help-center-categories">
            <div className="help-center-cards">
              {cards.map((card, index) => (
                <SimpleCard
                      key={index}
                  title={card.title}
                  description={card.description}
                  route={card.route}
                    />
                  ))}
                </div>
          </section>

          <LastUpdated />
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default GettingStarted;
